import List from "@/components/treeList";

const Table = args => {
  const { listeners, props } = args;
  const deleteRule = listeners["deleteRule"] || function () { };
  const displayCr = listeners["displayCr"] || function () { };
  const editRule = listeners["editRule"] || function () { };
  // 编辑
  function handleUpdate(row) {
    editRule({
      deptId: row.deptId,
      resourceType: row.resourceType
    });
  }

  //删除
  function handleDelete(row) {
    deleteRule({
      deptId: row.deptId,
      resourceType: row.resourceType
    });
  }

  //启用
  function handleDisplay(status, row, msg) {
    displayCr(status, {
      deptId: row.deptId,
      resourceType: row.resourceType
    }, msg)
  }

  const Deal = ({ props: { vo } }) => {
    const cr = vo.row;
    const dealConf = [
      ["编辑", () => handleUpdate(cr), "icon-edit", "creditRule:update"],
      ["删除", () => handleDelete(cr), "icon-delete", "creditRule:delete"]
    ];
    if (cr.ruleStatus === 1) {
      dealConf.push([
        "启用",
        () => handleDisplay(0, cr, "启用"),
        "icon-enable",
        "creditRule:display"
      ]);
    } else {
      dealConf.push([
        "停用",
        () => handleDisplay(1, cr, "停用"),
        "icon-unable",
        "creditRule:display"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const RuleRender = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <el-tooltip placement="top" content={row.ruleDetail}>
        <div class={'ellipsis--l2'}>
          {row.ruleDetail}
        </div>
      </el-tooltip>
    );
  }

  const AccountTableConfig = [
    {
      label: "类型名称",
      prop: "resourceTypeName",
      minWidth: "100"
    },
    {
      label: "所属组织",
      prop: "deptName",
      minWidth: "100"
    },
    {
      label: "时长规则",
      prop: "ruleDetail",
      minWidth: "300",
      showOverflowTooltip: true,
      render: vo => <RuleRender vo={vo} />
    },
    {
      label: "状态",
      prop: "ruleStatusName",
      width: "130"
    },
    {
      label: "操作",
      width: "150",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
